export default "__VITE_ASSET__ABwLRpDv__"